import { ArrowLeftOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';

export const BackIcon = (t, n) => {
  return {
    key: 'back',
    title: t('Späť'),
    onClick: () => n(-1),
    icon: <ArrowLeftOutlined />,
  };
};

export const NewsSignature = ({ nameOfCreator, dateOfCreation }) => {
  const { t } = useTranslation();

  // Responsive: stack vertically on mobile
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const mq = window.matchMedia('(max-width: 768px)');
    const handleChange = (e) => setIsMobile(e.matches);
    // set initial
    setIsMobile(mq.matches);
    // subscribe
    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', handleChange);
    } else {
      // Fallback for environments without addEventListener on MediaQueryList
      mq.onchange = handleChange;
    }
    return () => {
      if (typeof mq.removeEventListener === 'function') {
        mq.removeEventListener('change', handleChange);
      } else {
        mq.onchange = null;
      }
    };
  }, []);

  return (
    <div
      className="footer-wrapper"
      style={{ width: '100%', marginTop: '20px' }}
    >
      {nameOfCreator && (
        <div
          style={{
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: isMobile ? 'flex-start' : 'space-between',
            fontSize: '12px',
            color: '#555',
            gap: isMobile ? '6px' : undefined,
          }}
        >
          <div>
            <strong>{t('Autor')}:</strong> {nameOfCreator}
          </div>
          <div>
            <strong>{t('Vytvorené')}:</strong> {dateOfCreation}
          </div>
        </div>
      )}
    </div>
  );
};

export const FontAwesomeIcon = ({ icon, type = 'solid' }) => {
  return <i className={`fa-${type} fa-${icon}`}></i>;
};
